import { render, staticRenderFns } from "./SupplierRequiredDocumentation.vue?vue&type=template&id=53b5bc16&scoped=true&"
import script from "./SupplierRequiredDocumentation.vue?vue&type=script&lang=js&"
export * from "./SupplierRequiredDocumentation.vue?vue&type=script&lang=js&"
import style0 from "./SupplierRequiredDocumentation.vue?vue&type=style&index=0&id=53b5bc16&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b5bc16",
  null
  
)

export default component.exports